import { render, staticRenderFns } from "./RegisterSale.vue?vue&type=template&id=2f89e02b&scoped=true&"
import script from "./RegisterSale.vue?vue&type=script&lang=js&"
export * from "./RegisterSale.vue?vue&type=script&lang=js&"
import style0 from "./RegisterSale.vue?vue&type=style&index=0&id=2f89e02b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f89e02b",
  null
  
)

export default component.exports